var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartmobileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/shopping-cart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66669 1.66675H3.11669C4.01669 1.66675 4.72502 2.44175 4.65002 3.33341L3.95835 11.6334C3.84169 12.9917 4.91668 14.1584 6.28335 14.1584H15.1584C16.3584 14.1584 17.4084 13.1751 17.5 11.9834L17.95 5.73342C18.05 4.35009 17 3.22508 15.6084 3.22508H4.85003",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5417 18.3333C14.117 18.3333 14.5833 17.867 14.5833 17.2917C14.5833 16.7164 14.117 16.25 13.5417 16.25C12.9664 16.25 12.5 16.7164 12.5 17.2917C12.5 17.867 12.9664 18.3333 13.5417 18.3333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.87498 18.3333C7.45028 18.3333 7.91665 17.867 7.91665 17.2917C7.91665 16.7164 7.45028 16.25 6.87498 16.25C6.29968 16.25 5.83331 16.7164 5.83331 17.2917C5.83331 17.867 6.29968 18.3333 6.87498 18.3333Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M7.5 6.66675H17.5",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartmobileicon);
export default __webpack_public_path__ + "static/media/cartmobileicon.04583d19.svg";
export { ForwardRef as ReactComponent };